import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import { contributionExportColumns } from '../../config/exportColumns/contributionExportColumns'
import { appAllGetContribution } from '../../store/contribution'
import TableFilter from './tableFilter'

function Contribution() {
	const dispatch = useDispatch()

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Contribution</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appAllGetContribution({ ...params, loading: false }))}
							filters={{}}
							columns={contributionExportColumns}
							fileName="Contributions"
							sheetName="Contribution List"
							buttonText="Export Contributions"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default Contribution
